import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import { useIsMobile } from "../hooks/useIsMobile";

// Cinematic page entrance: a staggered rise on the content plus a one-shot gold light sweep.
// Phones get a lighter, blur-free version so the transition stays at 60fps.
export default function PageTransition({ children }) {
  const { pathname } = useLocation();
  const mobile = useIsMobile();
  return (
    <>
      <motion.div
        key={pathname}
        initial={mobile ? { opacity: 0, y: 12 } : { opacity: 0, y: 20, filter: "blur(6px)" }}
        animate={mobile ? { opacity: 1, y: 0 } : { opacity: 1, y: 0, filter: "blur(0px)" }}
        transition={{ duration: mobile ? 0.35 : 0.6, ease: [0.22, 1, 0.36, 1] }}
        data-testid="page-transition"
      >
        {children}
      </motion.div>

      {!mobile && (
        <motion.div
          key={`sweep-${pathname}`}
          className="pointer-events-none fixed inset-0 z-[60] overflow-hidden"
          initial={{ opacity: 1 }}
          animate={{ opacity: 0 }}
          transition={{ duration: 1.15, ease: "easeInOut" }}
        >
          <motion.div
            className="absolute inset-y-0 w-2/5 page-sweep-band"
            initial={{ x: "-140%" }}
            animate={{ x: "320%" }}
            transition={{ duration: 1.05, ease: [0.4, 0, 0.2, 1] }}
          />
        </motion.div>
      )}
    </>
  );
}
